export const TEXTFIELD_MAX_CHARACTERS = 100
export const CUSTOM_PERSONAL_MESSAGE_MAX_CHARACTERS = 200
